import { t } from '@lingui/core/macro';
import { NumberRangeFilter } from './NumberRangeFilter';
export const totalContractValueFilterLabel = () => t({
    message: 'Total contract value',
    comment: 'Insights: Total contract value filter',
});
export function TotalContractValueFilter() {
    return <NumberRangeFilter name="metadataDocumentTotalContractValue" label={totalContractValueFilterLabel()}/>;
}
